import React from "react";
import style from "../Style.module.css";

const Pattern2 = ({ color = "#2F2F2F", ...props }) => {
  return (
    <svg
      className={style.svgBackground}
      height="100%"
      viewBox="30 0 252 346"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M156 278.25C242.156 278.25 312 236.724 312 185.5C312 134.276 242.156 92.75 156 92.75C69.8436 92.75 0 134.276 0 185.5C0 236.724 69.8436 278.25 156 278.25Z"
        fill={color}
        opacity={0.1}
      />
      <path
        d="M156 278.25C69.8392 278.25 0 319.781 0 371H311.914C312 319.781 242.161 278.25 156 278.25Z"
        fill={color}
        opacity={0.1}
      />
      <path
        d="M156 92.75C69.8392 92.75 0 51.2186 0 0H311.914C312 51.2186 242.161 92.75 156 92.75Z"
        fill={color}
        opacity={0.1}
      />
    </svg>
  );
};

export default Pattern2;
